export function buildSharedDocumentDownloadUrl({
  apiUrl,
  issueId,
  documentId,
  token,
  eventId,
  incomingEmailMessageId,
  linkedDocumentationId,
}: {
  apiUrl: string;
  issueId: string;
  documentId: string | number | undefined;
  token: string;
  eventId?: string;
  incomingEmailMessageId?: string;
  linkedDocumentationId?: string;
}): string {
  const encodedToken = encodeURIComponent(token);

  if (linkedDocumentationId) {
    return `${apiUrl}/v2/shared/issue/${issueId}/documentation/${linkedDocumentationId}/download?token=${encodedToken}`;
  }

  if (incomingEmailMessageId) {
    return `${apiUrl}/v2/shared/issue/${issueId}/incomingEmailMessage/${incomingEmailMessageId}/document/${documentId}/download?token=${encodedToken}`;
  }

  if (eventId) {
    return `${apiUrl}/v2/shared/issue/${issueId}/event/${eventId}/document/${documentId}/download?token=${encodedToken}`;
  }

  return `${apiUrl}/v2/shared/issue/${issueId}/document/${documentId}/download?token=${encodedToken}`;
}

export function buildSharedReportDownloadUrl({
  apiUrl,
  reportId,
  token,
}: {
  apiUrl: string;
  reportId: string;
  token: string;
}): string {
  return `${apiUrl}/v2/report/${reportId}/download?token=${encodeURIComponent(token)}`;
}
